import { getManagementApiBaseUrl } from '../../utils/management-api';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export class WebappsCidEndpoint {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${getManagementApiBaseUrl()}/webappsCid`;
	}

	list() {
		return `${this.baseUrl}/`;
	}

	linkedCids() {
		return `${this.baseUrl}/linkedCids`;
	}

	getCids(cid: id) {
		return `${this.baseUrl}/${cid}/cids`;
	}

	getSegments(cid: id) {
		return `${this.baseUrl}/${cid}/segments`;
	}

	getCampaigns(cid: id) {
		return `${this.baseUrl}/${cid}/campaigns`;
	}

	createSegments(cid: id) {
		return `${this.baseUrl}/${cid}/segmentsCreator`;
	}

	replaceCid(cid: id) {
		return `${this.baseUrl}/${cid}/cidReplacer`;
	}
}
